// extracted by mini-css-extract-plugin
module.exports = {"searchPage":"Search_searchPage__-u_US","results":"Search_results__1jiIS","noResults":"Search_noResults__2cuOi"};